import React from 'react';
import ReportsMenu from './ReportsMenu';
import PowerBIPortal from './PowerBIPortal';
import { usePortal } from '../../../contexts/PortalContext';
import './PowerBILayout.scss';

const PowerBILayout = () => {
  const { isReportMenuCollapsed, showMobileStickyHeader } = usePortal();

  return (
    <div className={`powerbi-layout ${showMobileStickyHeader ? 'has-mobile-sticky-header' : ''}`}>
      <ReportsMenu />
      <div className={`powerbi-content ${isReportMenuCollapsed ? 'menu-collapsed' : ''}`}>
        <PowerBIPortal />
      </div>
    </div>
  );
};

export default PowerBILayout;
